import { GameStats } from '../../lib/localStorage';
import { Progress } from './Progress';

type Props = {
  gameStats?: GameStats;
  isGameWon?: boolean;
  paramValue?: any;
  headerTitle?: any;
  signupModuleToggler?: any;
  signupModuleURL? : any;
  signupModelDescription? : any;
};

export const Histogram = ({ gameStats, isGameWon = false, paramValue, headerTitle, signupModuleToggler, signupModuleURL ,signupModelDescription }: Props) => {
  const winDistribution = gameStats?.winDistribution;
  const maxValue = winDistribution && Array.isArray(winDistribution) ? Math.max(...winDistribution) : 0;
  // alert(maxValue);
  if (!winDistribution || !Array.isArray(winDistribution)) {
    return <div>No data available</div>;
  }
  return (
    <>
      <div className=" min_height flex pp-two text-sm dark:text-white backGroundColor" style={{ marginBottom: '25px' }}>
        {winDistribution.map((value, i) => (

          <Progress
            key={i}
            index={i}
            size={90 * (value / maxValue)}
            label={String(value)}
            isGameWon={isGameWon}
          />
        ))}
      </div>
      {
        signupModuleToggler && (
          <div className={paramValue === 'true' || paramValue == 'true' ? 'is-embed' : ''} style={{ marginBottom: '20px' }}>
            <div className='notsigned-up-yet'>
              <div className='notsigned-text'>Not signed up yet?</div>
              <div className='notsigned-innertext' >{signupModelDescription}</div>
              <a className='No-thanks signup-itsfree' href={signupModuleURL} target="_blank" rel="noopener noreferrer"  >Sign up</a>
            </div>
          </div>
        )
      }
    </>
  )
}
